import { ExperimentConfig } from "./bucketing";

// allInOne design: ONE experiment key drives all three Book-CTA touchpoints.
// A user bucketed into A sees Control everywhere; B sees Variant everywhere.
// Trade-off: can't isolate which surface drove the result. See README.
export const BOOK_CTA_KEY = "book-cta-prominence";

export const EXPERIMENTS: Record<string, ExperimentConfig> = {
  [BOOK_CTA_KEY]: {
    key: BOOK_CTA_KEY,
    status: "paused",
    variants: [
      { name: "A", weight: 50 }, // Control: buttons hidden, label "Shop travel"
      { name: "B", weight: 50 }, // Variant: buttons shown, label "Book Your Adventure"
    ],
  },
};
